var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-avatar',{staticClass:"wrapper",attrs:{"size":_vm.size,"rounded":"","badge-offset":"-5px","badge":_vm.badgeContent,"badge-variant":"info"}},_vm._l((_vm.users),function(user,index){return _c('Avatar',{key:index,attrs:{"size":user.size,"shape":"square","user":user}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }